import Model from '@/models/Model'

export default class GUser extends Model {
    resource() {
        return 'g_user'
    }
}